import { jsx as o } from "react/jsx-runtime";
import { DealStatus as c } from "../../../../../types/Deal/index.js";
import { SaveActions as d } from "../SaveActions/index.js";
import { Container as p } from "./style.js";
const A = ({
  deal: t,
  isSaved: r,
  isNotificationsActived: a,
  actionHandler: i
}) => {
  const { id: n, status: s } = t, m = s !== c.ACTIVE;
  return /* @__PURE__ */ o(p, { children: /* @__PURE__ */ o(
    d,
    {
      commands: ({ type: e }) => i({ type: e, payload: { id: n } }),
      isInactive: m,
      isSaved: r,
      isNotificationsActived: a
    }
  ) });
};
export {
  A as DealSavedCardActions
};
